import React, { Component } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { PopupActionButton } from "../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import Image from "react-bootstrap/Image";
import SuperAdminReasonForCancellation from "../popup/SuperAdminReasonForCancellation";
//import ReusableSuccessMessage from "../successMesagePopup/ReusableSuccessMessage";
import SuperAdminEnterTableNumber from "../popup/SuperAdminEnterTableNumber";
import { ReusableOnboardingButton } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import SuperAdminEditWaitTime from "../popup/SuperAdminEditWaitTime";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../../store/actions/errorActions";
import {
  vendor_all_completed_diner,
  vendor_reset_diner_request,
  get_diner_reservation,
  vendor_accept_pending_diner,
} from "../../../../../../store/actions/dashboardAction/addingAction";
import {
  super_admin_diner_status_change,
  get_all_vendor_seating_information,
  get_all_vendor_history_information,
  super_admin_mark_all_completed_diner,
} from "../../../../../../store/actions/SuperAdminActions/adminSeatingDashboardAllAction";
import isEmpty from "../../../../../../store/validation/is-Empty";
import store from "../../../../../../store/store";
import { SET_VENDOR_INFORMATION } from "../../../../../../store/types";

export class StatusChangeAction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openSuccessRecord: false,
      allData: {},
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (!isEmpty(nextProps.dataSend) !== nextState.allData) {
      return {
        allData: nextProps.dataSend,
      };
    }
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };
  onCloseModal = () => {
    this.setState({ open: false });
  };

  onOpenModalSuccessRecord = () => {
    this.setState({ openSuccessRecord: true });
  };
  onCloseModalSuccessRecord = () => {
    this.setState({ openSuccessRecord: false });
  };

  recordCompleted = (e) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const vendor_id = this.state.allData.vendor_id;
    const formData = {
      markComplete: true,
    };
    this.props.super_admin_mark_all_completed_diner(
      formData,
      vendor_id,
      token,
      this.recordCompletedSuccess
    );
  };

  recordCompletedSuccess = (e) => {
    const data = { vendor_id: this.state.allData.vendor_id };
    this.props.get_all_vendor_history_information(data);
    this.props.get_all_vendor_seating_information(data);
    store.dispatch({
      type: SET_VENDOR_INFORMATION,
      payload: this.state.allData,
    });
    this.setState({
      open: false,
      openSuccessRecord: true,
    });
  };

  historyReset = (e) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const diner_id = this.state.allData._id;
    // const vendor_id = this.state.allData.vendor_id;
    if (this.state.allData.diner_status === "COMPLETED") {
      const formData = {
        diner_status: "SEATED",
      };
      this.props.super_admin_diner_status_change(
        formData,
        diner_id,
        // vendor_id,
        token,
        this.completedToResetSuccess
      );
    } else if (this.state.allData.diner_status === "SEATED") {
      const formData = {
        diner_status: "NOTSEATED",
      };
      this.props.super_admin_diner_status_change(
        formData,
        diner_id,
        // vendor_id,
        token,
        this.completedToResetSuccess
      );
    } else if (this.state.allData.diner_status === "NOTSEATED") {
      const formData = {
        diner_status: "PENDING",
      };
      this.props.super_admin_diner_status_change(
        formData,
        diner_id,
        // vendor_id,
        token,
        this.completedToResetSuccess
      );
    } else {
      const formData = {
        diner_status: "PENDING",
      };
      this.props.super_admin_diner_status_change(
        formData,
        diner_id,
        // vendor_id,
        token,
        this.completedToResetSuccess
      );
    }
  };

  completedToResetSuccess = (e) => {
    const data = { vendor_id: this.state.allData.vendor_id };
    this.props.get_all_vendor_history_information(data);
    this.props.get_all_vendor_seating_information(data);
    store.dispatch({
      type: SET_VENDOR_INFORMATION,
      payload: this.state.allData,
    });
    this.onCloseModal();
  };

  historyUnseated = (e) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const diner_id = this.state.allData._id;
    // const vendor_id = this.state.allData.vendor_id;
    const formData = {
      diner_status: "NOTSEATED",
    };
    this.props.super_admin_diner_status_change(
      formData,
      diner_id,
      // vendor_id,
      token,
      this.onHistoryUnseatedSuccess
    );
  };

  onHistoryUnseatedSuccess = (e) => {
    const data = { vendor_id: this.state.allData.vendor_id };
    this.props.get_all_vendor_history_information(data);
    this.props.get_all_vendor_seating_information(data);
    store.dispatch({
      type: SET_VENDOR_INFORMATION,
      payload: this.state.allData,
    });
    this.onCloseModal();
  };

  historyCompleted = (e) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const diner_id = this.state.allData._id;
    // const vendor_id = this.state.allData.vendor_id;
    const formData = {
      diner_status: "COMPLETED",
    };
    this.props.super_admin_diner_status_change(
      formData,
      diner_id,
      // vendor_id,
      token,
      this.onHistoryCompletedSuccess
    );
  };

  onHistoryCompletedSuccess = (e) => {
    const data = { vendor_id: this.state.allData.vendor_id };
    this.props.get_all_vendor_history_information(data);
    this.props.get_all_vendor_seating_information(data);
    store.dispatch({
      type: SET_VENDOR_INFORMATION,
      payload: this.state.allData,
    });
    this.onCloseModal();
  };

  seatingCompleted = (e) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const diner_id = this.state.allData._id;
    // const vendor_id = this.state.allData.vendor_id;
    const formData = {
      diner_status: "COMPLETED",
    };
    this.props.super_admin_diner_status_change(
      formData,
      diner_id,
      // vendor_id,
      token,
      this.onCompletedSuccess
    );
  };

  onCompletedSuccess = (e) => {
    const data = { vendor_id: this.state.allData.vendor_id };
    this.props.get_all_vendor_seating_information(data);
    store.dispatch({
      type: SET_VENDOR_INFORMATION,
      payload: this.state.allData,
    });
    this.onCloseModal();
  };

  seatingUnseated = (e) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const diner_id = this.state.allData._id;
    // const vendor_id = this.state.allData.vendor_id;
    const formData = {
      diner_status: "NOTSEATED",
      table_number: 0,
    };
    this.props.super_admin_diner_status_change(
      formData,
      diner_id,
      // vendor_id,
      token,
      this.onUnseatedSuccess
    );
  };

  onUnseatedSuccess = (e) => {
    const data = { vendor_id: this.state.allData.vendor_id };
    this.props.get_all_vendor_seating_information(data);
    store.dispatch({
      type: SET_VENDOR_INFORMATION,
      payload: this.state.allData,
    });
    this.onCloseModal();
  };

  /***********************************************
   * @DESC Pending Reservation Accepted
   **********************************************/
  pendingReservationAccepted = (dataSend) => (e) => {
    e.preventDefault();
    const updatedTime = new Date(dataSend.reservationTime);
    const currentTimeTwo = new Date().getTime();
    const newcurrentTime = Math.floor(currentTimeTwo / (1000 * 60));
    const updatedTimeNew = updatedTime.getTime();
    const newUpdatedTime = Math.floor(updatedTimeNew / (1000 * 60));
    const waitTime = newUpdatedTime - newcurrentTime;
    const token = this.props.auth.user.accessToken;
    const diner_id = dataSend._id;
    const formData = {
      wait_time: waitTime,
      diner_status: "NOTSEATED",
    };
    this.props.super_admin_diner_status_change(
      formData,
      diner_id,
      // vendor_id,
      token,
      this.onAcceptSuccess
    );
  };

  onAcceptSuccess = (e) => {
    const data = { vendor_id: this.state.allData.vendor_id };
    this.props.get_all_vendor_seating_information(data);
    store.dispatch({
      type: SET_VENDOR_INFORMATION,
      payload: this.state.allData,
    });
    this.onCloseModal();
  };

  render() {
    const { open, openSuccessRecord } = this.state;
    return (
      <React.Fragment>
        {this.props.buttonDisplay === "offerEventDelete" ? (
          <div className="offers-event-deletebutton">
            <Image
              src={require("../../../../../../assets/images/ActionImages/delete.png")}
              alt="Delete"
              title="Delete"
              className="offers-event-delete"
              onClick={this.onOpenModal}
            />
          </div>
        ) : null || this.props.buttonDisplay === "bigCancelButton" ? (
          <PopupActionButton
            buttonText={this.props.buttonText}
            buttonType="button"
            buttonClass="cancel"
            onClick={this.onOpenModal}
          />
        ) : null || this.props.buttonDisplay === "smallCancelButton" ? (
          <PopupActionButton
            buttonText={this.props.buttonText}
            buttonType="button"
            buttonClass="smallcancel"
            onClick={this.onOpenModal}
          />
        ) : null || this.props.buttonDisplay === "smallSaveButton" ? (
          <PopupActionButton
            buttonText={this.props.buttonText}
            buttonType="button"
            buttonClass="smallsave"
            onClick={this.onOpenModal}
          />
        ) : null || this.props.buttonDisplay === "deleteButton" ? (
          <PopupActionButton
            buttonText={this.props.buttonText}
            buttonType="button"
            buttonClass="cancel"
            onClick={this.onOpenModal}
          />
        ) : null || this.props.buttonDisplay === "completedRecord" ? (
          <Image
            fluid
            src={require("../../../../../../assets/images/AuthImages/checked.png")}
            alt="Checked"
            title="All Record"
            className="checked-images"
            onClick={this.onOpenModal}
          />
        ) : null || this.props.buttonDisplay === "superAdminDeleteIcon" ? (
          <div className="super-admin-icon-box-width">
            <Image
              src={require("../../../../../../assets/images/ActionImages/delete.png")}
              alt="Delete"
              title="Delete Icon"
              onClick={this.onOpenModal}
              fluid
            />
          </div>
        ) : null || this.props.buttonDisplay === "superAdminRemoveReview" ? (
          <div className="super-admin-icon-box-width">
            <Image
              src={require("../../../../../../assets/images/superadmin/removebutton.svg")}
              alt="Delete"
              title="Delete Icon"
              onClick={this.onOpenModal}
              fluid
            />
          </div>
        ) : null || this.props.buttonDisplay === "superAdminApprovedReview" ? (
          <div className="super-admin-icon-box-width">
            <Image
              src={require("../../../../../../assets/images/superadmin/rightbutton.svg")}
              alt="Delete"
              title="Delete Icon"
              onClick={this.onOpenModal}
              fluid
            />
          </div>
        ) : null ||
          this.props.buttonDisplay === "superAdminNotificationView" ? (
          <div className="super-admin-icon-box-width m-auto">
            <Image
              src={require("../../../../../../assets/images/OfferAndEventImages/view.png")}
              alt="View"
              title="View Icon"
              // onClick={this.onOpenModal}
              fluid
            />
          </div>
        ) : null || this.props.buttonDisplay === "superAdminUserFlag" ? (
          <div className="super-admin-icon-box-width m-auto">
            <Image
              src={require("../../../../../../assets/images/iconButton/flag.png")}
              alt="View"
              title="View Icon"
              onClick={this.onOpenModal}
              fluid
            />
          </div>
        ) : null || this.props.buttonDisplay === "superAdminUserBlock" ? (
          <div className="super-admin-icon-box-width m-auto">
            <Image
              src={require("../../../../../../assets/images/iconButton/lock.png")}
              alt="View"
              title="View Icon"
              onClick={this.onOpenModal}
              fluid
            />
          </div>
        ) : null}
        <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "small-popup",
            closeButton:
              this.props.displayButton === true
                ? "customCloseButtonCalling"
                : "customCloseButton",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div>
            <div className="reusable-popup-header-newstyle">
              {this.props.display === true ? (
                <h4 className="c-black font_24_b">{this.props.bigText}</h4>
              ) : (
                <h4 className="c-black font_24_b">{this.props.bigText}</h4>
              )}
            </div>
            <h4 className="font_20_r mt-5 mb-5">{this.props.reasonText}</h4>
            {/* <div className="bottom-button"> */}
            <div className="d-flex">
              <ReusableOnboardingButton
                buttonTitle="No Button"
                buttonClass={
                  "onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                }
                buttonText="No"
                onClick={this.onCloseModal}
                buttonType="button"
              />
              {this.props.displayPopup === "resonFforCancellation" ? (
                <SuperAdminReasonForCancellation
                  buttonText="Yes"
                  cancelActionCall={this.props.actionCall}
                  onOpen={this.onOpenModal}
                  closedMainModal={this.onCloseModal}
                  allDataProps={this.props.dataSend}
                />
              ) : null ||
                this.props.displayPopup === "acceptButtonReservation" ? (
                <PopupActionButton
                  buttonText="Yes"
                  buttonType="button"
                  buttonClass="yesButton"
                  onClick={this.pendingReservationAccepted(this.props.dataSend)}
                />
              ) : null || this.props.displayPopup === "acceptButton" ? (
                <SuperAdminEditWaitTime
                  buttonText="Yes"
                  editButtonStatus="pendingEdit"
                  closedMainModal={this.onCloseModal}
                  allDataProps={this.props.dataSend}
                />
              ) : null || this.props.displayPopup === "SeatedButton" ? (
                <SuperAdminEnterTableNumber
                  buttonText="Yes"
                  editButtonStatus="pendingEdit"
                  closedMainModal={this.onCloseModal}
                  allDataProps={this.props.dataSend}
                />
              ) : null || this.props.displayPopup === "deleteButton" ? (
                <PopupActionButton
                  buttonText="Yes"
                  buttonType="button"
                  buttonClass="bigbuttongray"
                  onClick={this.props.deleteClick}
                />
              ) : null || this.props.displayPopup === "completedRecord" ? (
                <PopupActionButton
                  buttonText="Yes"
                  buttonType="button"
                  buttonClass="yesButton"
                  onClick={this.recordCompleted}
                />
              ) : null || this.props.displayPopup === "historyReset" ? (
                <PopupActionButton
                  buttonText="Yes"
                  buttonType="button"
                  buttonClass="yesButton"
                  onClick={this.historyReset}
                />
              ) : null || this.props.displayPopup === "historyUnseated" ? (
                <PopupActionButton
                  buttonText="Yes"
                  buttonType="button"
                  buttonClass="yesButton"
                  onClick={this.historyUnseated}
                />
              ) : null || this.props.displayPopup === "historyCompleted" ? (
                <PopupActionButton
                  buttonText="Yes"
                  buttonType="button"
                  buttonClass="yesButton"
                  onClick={this.historyCompleted}
                />
              ) : null || this.props.displayPopup === "seatingCompleted" ? (
                <PopupActionButton
                  buttonText="Yes"
                  buttonType="button"
                  buttonClass="yesButton"
                  allDataProps={this.props.dataSend}
                  onClick={this.seatingCompleted}
                />
              ) : null || this.props.displayPopup === "seatingUnseated" ? (
                <PopupActionButton
                  buttonText="Yes"
                  buttonType="button"
                  buttonClass="yesButton"
                  allDataProps={this.props.dataSend}
                  onClick={this.seatingUnseated}
                />
              ) : null}
              {/* <PopupActionButton
                buttonText="No"
                buttonType="button"
                buttonClass="bigbuttonred"
                onClick={this.onCloseModal}
              /> */}
            </div>
          </div>
        </Modal>
        <SuccessRecordPopup
          openSuccess={openSuccessRecord}
          onCloseModal={this.onCloseModalSuccessRecord}
          bigText="Record Success"
          smallText="No more requests to be completed"
        />
      </React.Fragment>
    );
  }
}

StatusChangeAction.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  allDinnerDetails: state.allDinerDetails.vendor_all_diner,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  vendor_all_completed_diner,
  vendor_reset_diner_request,
  super_admin_diner_status_change,
  get_all_vendor_seating_information,
  get_diner_reservation,
  get_all_vendor_history_information,
  super_admin_mark_all_completed_diner,
  vendor_accept_pending_diner,
})(withRouter(StatusChangeAction));

const SuccessRecordPopup = ({
  openSuccess,
  onCloseModal,
  bigText,
  smallText,
}) => {
  return (
    <React.Fragment>
      <Modal
        open={openSuccess}
        onClose={onCloseModal}
        center
        classNames={{
          overlay: "customOverlay-request-accept-cancelled",
          modal: "small-popup",
          closeButton: "customCloseButton",
          animationIn: "customEnterAnimation",
          animationOut: "customLeaveAnimation",
        }}
        animationDuration={1000}
      >
        <div>
          <div className="reusble-popup-header-style">
            <h4>{bigText}</h4>
          </div>
          <div className="bottom-button">
            <p className="col-12 mt-3">{smallText}</p>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};
